var _rect, _path, _path2, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuoyixian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4014 3.07221C12.4904 2.6167 11.4477 2.5 11 2.5V1.5C11.5523 1.5 12.7596 1.6333 13.8486 2.17779C14.959 2.73299 16 3.7526 16 5.5C16 7.2474 14.959 8.26701 13.8486 8.82221C12.7596 9.3667 11.5523 9.5 11 9.5V8.5C11.4477 8.5 12.4904 8.3833 13.4014 7.92779C14.291 7.48299 15 6.7526 15 5.5C15 4.2474 14.291 3.51701 13.4014 3.07221Z",
    fill: "#00C2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.74274 12.5713L7.74274 9.57129L8.25723 10.4288L3.25723 13.4288L2.74274 12.5713Z",
    fill: "#00C2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoyixian);
export default __webpack_public_path__ + "static/media/duoyixian.16c031ce8ee18c09358d38d750724dff.svg";
export { ForwardRef as ReactComponent };